import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 4px;
  position: relative;
`;

export const Label = styled.span`
  color: #101113;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%; /* 16.8px */
`;

export const Control = styled.div`
  display: flex;
  width: 100%;
  border: 1px solid ${({ isFocused }) => (isFocused ? '#228be6' : '#CED4DA')};
  justify-content: space-between;
  background: #fff;
  padding: 0 6px;
  border-radius: 4px;
  height: 30px;

  input {
    background-color: transparent;
    outline: none;
    border: none;
    width: 100%;
    height: auto;
    color: #5c5d61;
    font-size: 10px;
    font-weight: 500;
    line-height: 12.13px;
    text-align: left;
  }

  button {
    display: flex;
    align-items: center;
  }

  .rotated {
    transform: rotate(-90deg);
  }
`;

export const Menu = styled.ul`
  // position: absolute;
  // top: calc(100% + 5px);
  margin: 0;
  padding: 8px;
  border: 1px solid #ced4da;
  background: #fff;
  border-radius: 6px;
  min-width: 120px;
  width: 100%;
  max-height: 156px;
  overflow-y: auto;
`;

export const Option = styled.li`
  margin-top: 5px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 20px;
  padding: 4px;
  border-radius: 4px;
  background-color: #fff;

  svg {
    cursor: pointer;
  }

  span {
    max-width: 80%;
    overflow: hidden;
    display: inline-block;
    text-overflow: ellipsis;
    white-space: nowrap;

    font-size: 10px;
    font-weight: 500;
    line-height: 12.13px;
    text-align: left;
    color: #5c5d61;
  }
`;
